import { apiService } from '@/lib/api';
import { AttachmentsModal } from '@/components/AttachmentsModal';

interface EstimateAttachmentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  estimateId: string;
  /** Converted estimates: view and download only. */
  readOnly?: boolean;
  onAttachmentsUpdated: () => void;
  /** Opened from the estimate's PDF button: new uploads are added to the estimate PDF. */
  uploadsIncludedInPdf?: boolean;
}

export function EstimateAttachmentsModal({ isOpen, onClose, estimateId, readOnly, onAttachmentsUpdated, uploadsIncludedInPdf }: EstimateAttachmentsModalProps) {
  return (
    <AttachmentsModal
      isOpen={isOpen}
      onClose={onClose}
      ownerId={estimateId}
      title="Estimate Attachments"
      queryKey="estimateAttachments"
      readOnly={readOnly}
      onAttachmentsUpdated={onAttachmentsUpdated}
      fetchAttachments={apiService.getEstimateAttachments.bind(apiService)}
      prepareUpload={apiService.prepareEstimateAttachmentUpload.bind(apiService)}
      completeUpload={apiService.completeEstimateAttachmentUpload.bind(apiService)}
      getDownloadUrl={apiService.getEstimateAttachmentDownloadUrl.bind(apiService)}
      updateAttachment={apiService.updateEstimateAttachment.bind(apiService)}
      deleteAttachment={apiService.deleteEstimateAttachment.bind(apiService)}
      pdf={{
        document: 'estimate',
        setIncluded: (id, attachmentId, included) => apiService.updateEstimateAttachment(id, attachmentId, { include_in_pdf: included }),
        uploadsIncluded: uploadsIncludedInPdf,
      }}
    />
  );
}
